/**
 * A six-digit code as typed, pasted or autofilled: "123 456", "123-456" and
 * "Your code is 123456" all become "123456". Digits only, at most six.
 */
export function cleanCode(raw: string): string {
  return raw.replace(/\D/g, '').slice(0, 6);
}
